import { LinkProps } from "react-router-dom";

import { ReactComponent as BillingIcon } from "libAssets/menuIcons/billing.svg";
import { ReactComponent as MonitoringIcon } from "libAssets/menuIcons/monitoring.svg";
import { ReactComponent as AutomationIcon } from "libAssets/menuIcons/automation.svg";
import { ReactComponent as StoreIcon } from "libAssets/menuIcons/store.svg";
import { ReactComponent as DecarbIcon } from "libAssets/menuIcons/decarbonization.svg";
import { ReactComponent as SimulatorIcon } from "libAssets/menuIcons/simulator.svg";
import { ReactComponent as SolutionsIcon } from "libAssets/menuIcons/solutions.svg";
import { ReactComponent as BuildingsIcon } from "libAssets/menuIcons/buildings.svg";
import { ReactComponent as AlgaIcon } from "libAssets/menuIcons/alga.svg";
import { ReactComponent as InvestmentsIcon } from "libAssets/menuIcons/investments.svg";

export type MenuItem = {
  title: string;
  navigateTo: LinkProps["to"];
  display: boolean;
  Icon?: React.FC;
};

export const SIDE_MENU_DATA: Array<MenuItem> = [
  {
    title: "Economia",
    navigateTo: "/admin/billing",
    display: true,
    Icon: BillingIcon,
  },
  {
    title: "Monitoramento",
    navigateTo: "/admin/monitoring",
    display: true,
    Icon: MonitoringIcon,
  },
  {
    title: "Automação",
    navigateTo: "/admin/automation",
    display: true,
    Icon: AutomationIcon,
  },
  {
    title: "Loja virtual",
    navigateTo: "/frames/store",
    display: true,
    Icon: StoreIcon,
  },
  {
    title: "CO2e",
    navigateTo: "/admin/decarbonization",
    display: true,
    Icon: DecarbIcon,
  },
  {
    title: "Alga",
    navigateTo: "/frames/alga-ai",
    display: true,
    Icon: AlgaIcon,
  },
  {
    title: "Simulador",
    navigateTo: "/frames/simulator",
    display: true,
    Icon: SimulatorIcon,
  },
  {
    title: "Investimentos",
    navigateTo: "/admin/investments",
    display: true,
    Icon: InvestmentsIcon,
  },
  {
    title: "Soluções",
    navigateTo: "/solutions",
    display: true,
    Icon: SolutionsIcon,
  },
  {
    title: "Meus imóveis",
    navigateTo: "/admin/buildings/edit",
    display: true,
    Icon: BuildingsIcon,
  },
];
